import { KeyValuePair, DashboardPeriod } from '../models';

export const dashboardPeriods: KeyValuePair<DashboardPeriod, string>[] = [
    { key: DashboardPeriod.None, value: 'None' },
    { key: DashboardPeriod.Today, value: 'Today' },
    { key: DashboardPeriod.Last24H, value: 'Last 24h' },
    { key: DashboardPeriod.Yesterday, value: 'Yesterday' },
    { key: DashboardPeriod.Last7D, value: 'Last 7 days' },
    { key: DashboardPeriod.LastWeek, value: 'Last week' },
    { key: DashboardPeriod.ThisWeek, value: 'This week' },
    { key: DashboardPeriod.WeekToDate, value: 'Week to date' },
    { key: DashboardPeriod.Last30D, value: 'Last 30 days' },
    { key: DashboardPeriod.LastMonth, value: 'Last month' },
    { key: DashboardPeriod.ThisMonth, value: 'This month' },
    { key: DashboardPeriod.MonthToDate, value: 'Month to date' },
    { key: DashboardPeriod.NextMonth, value: 'Next month' },
    { key: DashboardPeriod.Last3Months, value: 'Last 3 months' },
    { key: DashboardPeriod.LastQuarter, value: 'Last quarter' },
    { key: DashboardPeriod.ThisQuarter, value: 'This quarter' },
    { key: DashboardPeriod.QuarterToDate, value: 'Quarter to date' },
    { key: DashboardPeriod.NextQuarter, value: 'Next quarter' },
    { key: DashboardPeriod.Last12Months, value: 'Last 12 months' },
    { key: DashboardPeriod.LastYear, value: 'Last year' },
    { key: DashboardPeriod.ThisYear, value: 'This year' },
    { key: DashboardPeriod.YearToDate, value: 'Year to date' },
    { key: DashboardPeriod.NextYear, value: 'Next year' }
];